import e, { sticky as t } from "tippy.js";
//#region components/popover/tippy_utils.js
var n = [
	"bottom",
	"bottom-start",
	"bottom-end",
	"right",
	"right-start",
	"right-end",
	"left",
	"left-start",
	"left-end",
	"top",
	"top-start",
	"top-end"
], r = [
	!0,
	!1,
	"reference",
	"popper"
], i = (n, r) => {
	let { contentElement: i } = { ...r };
	return delete r.contentElement, e(n, {
		...r,
		plugins: [t],
		render: () => l(i)
	});
}, a = (n, r) => e(n, {
	...r,
	plugins: [t]
}), o = ({ boundary: e = "clippingParents", fallbackPlacements: t = [], hasHideModifierEnabled: n = !1, tether: r = !0 } = {}) => ({ modifiers: [
	{
		name: "flip",
		options: {
			fallbackPlacements: t,
			boundary: e
		}
	},
	{
		name: "hide",
		enabled: n
	},
	{
		name: "preventOverflow",
		options: {
			altAxis: !r,
			tether: r,
			boundary: e
		}
	}
] }), s = (e) => {
	let t = document.createElement("span");
	return t.innerText = e.innerText || "", e.innerText = "", e.appendChild(t), t;
}, c = (e) => {
	if (!e) {
		console.warn("No anchor wrapper provided. This may cause issues with the popover.");
		return;
	}
	return e.children[0] || s(e);
}, l = (e) => {
	let t = document.createElement("div");
	return t.className = "tippy-box d-ps-absolute", t.appendChild(e), { popper: t };
};
//#endregion
export { n as BASE_TIPPY_DIRECTIONS, r as TIPPY_STICKY_VALUES, a as createTippy, i as createTippyPopover, c as getAnchor, l as getContentWrapper, o as getPopperOptions };

//# sourceMappingURL=tippy-utils.js.map